import { render, staticRenderFns } from "./SpaceDescription.component.vue?vue&type=template&id=7f519212&scoped=true"
import script from "./SpaceDescription.component.vue?vue&type=script&lang=js"
export * from "./SpaceDescription.component.vue?vue&type=script&lang=js"
import style0 from "./SpaceDescription.component.vue?vue&type=style&index=0&id=7f519212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f519212",
  null
  
)

export default component.exports